<template>
  <div>
    <div class="lib__text-center available-connection-bottom-link-container">
      <p class="available-connection-bottom-link-container">
        <a v-if="isSwdeDisplayed"
          class="lib__text-weight-400 available-connection-bottom-link lib__link__mobile--underline" target="_blank"
          :href="$t('new-connection-cmh.links.waterProvider')"> {{
            $t('new-connection-cmh.confirmation-step.waterProviderLinkText') }} </a>
      </p>
      <p class="available-connection-bottom-link-container">
        <a v-if="isProximusDisplayed"
          class="lib__text-weight-400 available-connection-bottom-link lib__link__mobile--underline" target="_blank"
          :href="$t('new-connection-cmh.links.proximus')">
          {{ $t('new-connection-cmh.yourConnection') }} {{ $t('operator.proximus') }}
        </a>
      </p>
      <p class="available-connection-bottom-link-container">
        <a v-if="isOrangeDisplayed"
          class="lib__text-weight-400 available-connection-bottom-link lib__link__mobile--underline" target="_blank"
          :href="$t('new-connection-cmh.links.voo')"> {{
            $t('new-connection-cmh.orangeElligible') }} </a>
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'cmh-providers-external-links'
})
export default class CmhProvidersExternalLinks extends Vue {
  @Prop({ type: Boolean, required: false, default: true }) public isSwdeDisplayed!: boolean
  @Prop({ type: Boolean, required: false, default: true }) public isProximusDisplayed!: boolean
  @Prop({ type: Boolean, required: false, default: true }) public isOrangeDisplayed!: boolean
}
</script>

<style scoped>
.available-connection-bottom-link-container {
  margin: 10px auto;
  width: 90%;
}

.available-connection-bottom-link {
  letter-spacing: 0;
  line-height: 20px;
  margin: 0px auto 10px;
  width: 100%;
}

@media screen and (min-width: 577px) {
  .available-connection-bottom-link {
    font-size: 18px;
  }
}

@media screen and (max-width: 576px) {

  .available-connection-bottom-link {
    font-size: 14px;
  }
}
</style>